// Simple session utilities to scope snapshots to a walkthrough session

const STORAGE_KEY = "ams.walkthrough.sessionId";

export function getOrCreateSessionId(): string {
  if (typeof window === "undefined") return "server-session";
  const existing = window.localStorage.getItem(STORAGE_KEY);
  if (existing && existing.length > 0) return existing;
  const id = `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
  window.localStorage.setItem(STORAGE_KEY, id);
  return id;
}

export function getSessionId(): string | null {
  if (typeof window === "undefined") return null;
  return window.localStorage.getItem(STORAGE_KEY);
}

export function resetSessionId(): void {
  if (typeof window === "undefined") return;
  window.localStorage.removeItem(STORAGE_KEY);
}

// Trainer active course: persists the cohortId while a trainer is viewing a course as participant
const TRAINER_COHORT_KEY = "ams.trainer.activeCohortId";

export function setTrainerActiveCohort(cohortId: string): void {
  if (typeof window === "undefined") return;
  window.sessionStorage.setItem(TRAINER_COHORT_KEY, cohortId);
}

export function getTrainerActiveCohort(): string | null {
  if (typeof window === "undefined") return null;
  return window.sessionStorage.getItem(TRAINER_COHORT_KEY);
}

export function clearTrainerActiveCohort(): void {
  if (typeof window === "undefined") return;
  window.sessionStorage.removeItem(TRAINER_COHORT_KEY);
}
